import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class TipoAutorizacionService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getAllTipoAutorizacion(): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_TIPO_AUTORIZACION;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Tipo Autorización",
            text: "Error Cargando Tipo Autorización.",
            icon: "error",
          });
        }
        return throwError(err);
      })
    );
  }
}
